module.exports = __webpack_public_path__ + "img/potion-extra-large.8844d981.svg";